type Region = "eu" | "na" | "sa" | "as" | "af" | "oc" | "me" | "ca" | "other"

export const SWRegions: Record<Region, { name: string; code: string }> = {
  eu: { name: "Europe", code: "eu" },
  na: { name: "North America", code: "na" },
  sa: { name: "South America", code: "sa" },
  as: { name: "Asia", code: "as" },
  af: { name: "Africa", code: "af" },
  oc: { name: "Oceania", code: "oc" },
  me: { name: "Middle East", code: "me" },
  ca: { name: "Central America", code: "ca" },
  other: { name: "Other", code: "other" },
}

export const SWCountries: Record<string, { code: string; name: string; region: Region }> = {
  AF: { code: "AF", name: "Afghanistan", region: "as" },
  AL: { code: "AL", name: "Albania", region: "eu" },
  DZ: { code: "DZ", name: "Algeria", region: "af" },
  AS: { code: "AS", name: "American Samoa", region: "oc" },
  AD: { code: "AD", name: "Andorra", region: "eu" },
  AO: { code: "AO", name: "Angola", region: "af" },
  AI: { code: "AI", name: "Anguilla", region: "na" },
  AQ: { code: "AQ", name: "Antarctica", region: "other" },
  AG: { code: "AG", name: "Antigua and Barbuda", region: "na" },
  AR: { code: "AR", name: "Argentina", region: "sa" },
  AM: { code: "AM", name: "Armenia", region: "as" },
  AW: { code: "AW", name: "Aruba", region: "na" },
  AU: { code: "AU", name: "Australia", region: "oc" },
  AT: { code: "AT", name: "Austria", region: "eu" },
  AZ: { code: "AZ", name: "Azerbaijan", region: "as" },
  BS: { code: "BS", name: "Bahamas", region: "na" },
  BH: { code: "BH", name: "Bahrain", region: "me" },
  BD: { code: "BD", name: "Bangladesh", region: "as" },
  BB: { code: "BB", name: "Barbados", region: "na" },
  BY: { code: "BY", name: "Belarus", region: "eu" },
  BE: { code: "BE", name: "Belgium", region: "eu" },
  BZ: { code: "BZ", name: "Belize", region: "ca" },
  BJ: { code: "BJ", name: "Benin", region: "af" },
  BM: { code: "BM", name: "Bermuda", region: "na" },
  BT: { code: "BT", name: "Bhutan", region: "as" },
  BO: { code: "BO", name: "Bolivia", region: "sa" },
  BA: { code: "BA", name: "Bosnia and Herzegovina", region: "eu" },
  BW: { code: "BW", name: "Botswana", region: "af" },
  BV: { code: "BV", name: "Bouvet Island", region: "other" },
  BR: { code: "BR", name: "Brazil", region: "sa" },
  IO: { code: "IO", name: "British Indian Ocean Territory", region: "as" },
  BN: { code: "BN", name: "Brunei Darussalam", region: "as" },
  BG: { code: "BG", name: "Bulgaria", region: "eu" },
  BF: { code: "BF", name: "Burkina Faso", region: "af" },
  BI: { code: "BI", name: "Burundi", region: "af" },
  KH: { code: "KH", name: "Cambodia", region: "as" },
  CM: { code: "CM", name: "Cameroon", region: "af" },
  CA: { code: "CA", name: "Canada", region: "na" },
  CV: { code: "CV", name: "Cape Verde", region: "af" },
  KY: { code: "KY", name: "Cayman Islands", region: "na" },
  CF: { code: "CF", name: "Central African Republic", region: "af" },
  TD: { code: "TD", name: "Chad", region: "af" },
  CL: { code: "CL", name: "Chile", region: "sa" },
  CN: { code: "CN", name: "China", region: "as" },
  CX: { code: "CX", name: "Christmas Island", region: "as" },
  CC: { code: "CC", name: "Cocos (Keeling) Islands", region: "as" },
  CO: { code: "CO", name: "Colombia", region: "sa" },
  KM: { code: "KM", name: "Comoros", region: "af" },
  CG: { code: "CG", name: "Congo", region: "af" },
  CD: { code: "CD", name: "Congo, the Democratic Republic of the", region: "af" },
  CK: { code: "CK", name: "Cook Islands", region: "oc" },
  CR: { code: "CR", name: "Costa Rica", region: "ca" },
  CI: { code: "CI", name: "Cote D'Ivoire", region: "af" },
  HR: { code: "HR", name: "Croatia", region: "eu" },
  CU: { code: "CU", name: "Cuba", region: "na" },
  CY: { code: "CY", name: "Cyprus", region: "eu" },
  CZ: { code: "CZ", name: "Czech Republic", region: "eu" },
  DK: { code: "DK", name: "Denmark", region: "eu" },
  DJ: { code: "DJ", name: "Djibouti", region: "af" },
  DM: { code: "DM", name: "Dominica", region: "na" },
  DO: { code: "DO", name: "Dominican Republic", region: "na" },
  EC: { code: "EC", name: "Ecuador", region: "sa" },
  EG: { code: "EG", name: "Egypt", region: "me" },
  SV: { code: "SV", name: "El Salvador", region: "ca" },
  GQ: { code: "GQ", name: "Equatorial Guinea", region: "af" },
  ER: { code: "ER", name: "Eritrea", region: "af" },
  EE: { code: "EE", name: "Estonia", region: "eu" },
  ET: { code: "ET", name: "Ethiopia", region: "af" },
  FK: { code: "FK", name: "Falkland Islands (Malvinas)", region: "sa" },
  FO: { code: "FO", name: "Faroe Islands", region: "eu" },
  FJ: { code: "FJ", name: "Fiji", region: "oc" },
  FI: { code: "FI", name: "Finland", region: "eu" },
  FR: { code: "FR", name: "France", region: "eu" },
  GF: { code: "GF", name: "French Guiana", region: "sa" },
  PF: { code: "PF", name: "French Polynesia", region: "oc" },
  TF: { code: "TF", name: "French Southern Territories", region: "other" },
  GA: { code: "GA", name: "Gabon", region: "af" },
  GM: { code: "GM", name: "Gambia", region: "af" },
  GE: { code: "GE", name: "Georgia", region: "as" },
  DE: { code: "DE", name: "Germany", region: "eu" },
  GH: { code: "GH", name: "Ghana", region: "af" },
  GI: { code: "GI", name: "Gibraltar", region: "eu" },
  GR: { code: "GR", name: "Greece", region: "eu" },
  GL: { code: "GL", name: "Greenland", region: "na" },
  GD: { code: "GD", name: "Grenada", region: "na" },
  GP: { code: "GP", name: "Guadeloupe", region: "na" },
  GU: { code: "GU", name: "Guam", region: "oc" },
  GT: { code: "GT", name: "Guatemala", region: "ca" },
  GN: { code: "GN", name: "Guinea", region: "af" },
  GW: { code: "GW", name: "Guinea-Bissau", region: "af" },
  GY: { code: "GY", name: "Guyana", region: "sa" },
  HT: { code: "HT", name: "Haiti", region: "na" },
  HM: { code: "HM", name: "Heard Island and Mcdonald Islands", region: "other" },
  VA: { code: "VA", name: "Holy See (Vatican City State)", region: "eu" },
  HN: { code: "HN", name: "Honduras", region: "ca" },
  HK: { code: "HK", name: "Hong Kong", region: "as" },
  HU: { code: "HU", name: "Hungary", region: "eu" },
  IS: { code: "IS", name: "Iceland", region: "eu" },
  IN: { code: "IN", name: "India", region: "as" },
  ID: { code: "ID", name: "Indonesia", region: "as" },
  IR: { code: "IR", name: "Iran, Islamic Republic of", region: "me" },
  IQ: { code: "IQ", name: "Iraq", region: "me" },
  IE: { code: "IE", name: "Ireland", region: "eu" },
  IL: { code: "IL", name: "Israel", region: "me" },
  IT: { code: "IT", name: "Italy", region: "eu" },
  JM: { code: "JM", name: "Jamaica", region: "na" },
  JP: { code: "JP", name: "Japan", region: "as" },
  JO: { code: "JO", name: "Jordan", region: "me" },
  KZ: { code: "KZ", name: "Kazakhstan", region: "as" },
  KE: { code: "KE", name: "Kenya", region: "af" },
  KI: { code: "KI", name: "Kiribati", region: "oc" },
  KP: { code: "KP", name: "Korea, Democratic People's Republic of", region: "as" },
  KR: { code: "KR", name: "Korea, Republic of", region: "as" },
  KW: { code: "KW", name: "Kuwait", region: "me" },
  KG: { code: "KG", name: "Kyrgyzstan", region: "as" },
  LA: { code: "LA", name: "Lao People's Democratic Republic", region: "as" },
  LV: { code: "LV", name: "Latvia", region: "eu" },
  LB: { code: "LB", name: "Lebanon", region: "me" },
  LS: { code: "LS", name: "Lesotho", region: "af" },
  LR: { code: "LR", name: "Liberia", region: "af" },
  LY: { code: "LY", name: "Libyan Arab Jamahiriya", region: "af" },
  LI: { code: "LI", name: "Liechtenstein", region: "eu" },
  LT: { code: "LT", name: "Lithuania", region: "eu" },
  LU: { code: "LU", name: "Luxembourg", region: "eu" },
  MO: { code: "MO", name: "Macao", region: "as" },
  MK: { code: "MK", name: "Macedonia, the Former Yugoslav Republic of", region: "eu" },
  MG: { code: "MG", name: "Madagascar", region: "af" },
  MW: { code: "MW", name: "Malawi", region: "af" },
  MY: { code: "MY", name: "Malaysia", region: "as" },
  MV: { code: "MV", name: "Maldives", region: "as" },
  ML: { code: "ML", name: "Mali", region: "af" },
  MT: { code: "MT", name: "Malta", region: "eu" },
  MH: { code: "MH", name: "Marshall Islands", region: "oc" },
  MQ: { code: "MQ", name: "Martinique", region: "na" },
  MR: { code: "MR", name: "Mauritania", region: "af" },
  MU: { code: "MU", name: "Mauritius", region: "af" },
  YT: { code: "YT", name: "Mayotte", region: "af" },
  MX: { code: "MX", name: "Mexico", region: "na" },
  FM: { code: "FM", name: "Micronesia, Federated States of", region: "oc" },
  MD: { code: "MD", name: "Moldova, Republic of", region: "eu" },
  MC: { code: "MC", name: "Monaco", region: "eu" },
  MN: { code: "MN", name: "Mongolia", region: "as" },
  MS: { code: "MS", name: "Montserrat", region: "na" },
  MA: { code: "MA", name: "Morocco", region: "af" },
  MZ: { code: "MZ", name: "Mozambique", region: "af" },
  MM: { code: "MM", name: "Myanmar", region: "as" },
  NA: { code: "NA", name: "Namibia", region: "af" },
  NR: { code: "NR", name: "Nauru", region: "oc" },
  NP: { code: "NP", name: "Nepal", region: "as" },
  NL: { code: "NL", name: "Netherlands", region: "eu" },
  AN: { code: "AN", name: "Netherlands Antilles", region: "na" },
  NC: { code: "NC", name: "New Caledonia", region: "oc" },
  NZ: { code: "NZ", name: "New Zealand", region: "oc" },
  NI: { code: "NI", name: "Nicaragua", region: "ca" },
  NE: { code: "NE", name: "Niger", region: "af" },
  NG: { code: "NG", name: "Nigeria", region: "af" },
  NU: { code: "NU", name: "Niue", region: "oc" },
  NF: { code: "NF", name: "Norfolk Island", region: "oc" },
  MP: { code: "MP", name: "Northern Mariana Islands", region: "oc" },
  NO: { code: "NO", name: "Norway", region: "eu" },
  OM: { code: "OM", name: "Oman", region: "me" },
  PK: { code: "PK", name: "Pakistan", region: "as" },
  PW: { code: "PW", name: "Palau", region: "oc" },
  PS: { code: "PS", name: "Palestinian Territory, Occupied", region: "me" },
  PA: { code: "PA", name: "Panama", region: "ca" },
  PG: { code: "PG", name: "Papua New Guinea", region: "oc" },
  PY: { code: "PY", name: "Paraguay", region: "sa" },
  PE: { code: "PE", name: "Peru", region: "sa" },
  PH: { code: "PH", name: "Philippines", region: "as" },
  PN: { code: "PN", name: "Pitcairn", region: "oc" },
  PL: { code: "PL", name: "Poland", region: "eu" },
  PT: { code: "PT", name: "Portugal", region: "eu" },
  PR: { code: "PR", name: "Puerto Rico", region: "na" },
  QA: { code: "QA", name: "Qatar", region: "me" },
  RE: { code: "RE", name: "Reunion", region: "af" },
  RO: { code: "RO", name: "Romania", region: "eu" },
  RU: { code: "RU", name: "Russian Federation", region: "eu" },
  RW: { code: "RW", name: "Rwanda", region: "af" },
  SH: { code: "SH", name: "Saint Helena", region: "af" },
  KN: { code: "KN", name: "Saint Kitts and Nevis", region: "na" },
  LC: { code: "LC", name: "Saint Lucia", region: "na" },
  PM: { code: "PM", name: "Saint Pierre and Miquelon", region: "na" },
  VC: { code: "VC", name: "Saint Vincent and the Grenadines", region: "na" },
  WS: { code: "WS", name: "Samoa", region: "oc" },
  SM: { code: "SM", name: "San Marino", region: "eu" },
  ST: { code: "ST", name: "Sao Tome and Principe", region: "af" },
  SA: { code: "SA", name: "Saudi Arabia", region: "me" },
  SN: { code: "SN", name: "Senegal", region: "af" },
  CS: { code: "CS", name: "Serbia and Montenegro", region: "eu" },
  SC: { code: "SC", name: "Seychelles", region: "af" },
  SL: { code: "SL", name: "Sierra Leone", region: "af" },
  SG: { code: "SG", name: "Singapore", region: "as" },
  SK: { code: "SK", name: "Slovakia", region: "eu" },
  SI: { code: "SI", name: "Slovenia", region: "eu" },
  SB: { code: "SB", name: "Solomon Islands", region: "oc" },
  SO: { code: "SO", name: "Somalia", region: "af" },
  ZA: { code: "ZA", name: "South Africa", region: "af" },
  GS: { code: "GS", name: "South Georgia and the South Sandwich Islands", region: "sa" },
  ES: { code: "ES", name: "Spain", region: "eu" },
  LK: { code: "LK", name: "Sri Lanka", region: "as" },
  SD: { code: "SD", name: "Sudan", region: "af" },
  SR: { code: "SR", name: "Suriname", region: "sa" },
  SJ: { code: "SJ", name: "Svalbard and Jan Mayen", region: "eu" },
  SZ: { code: "SZ", name: "Swaziland", region: "af" },
  SE: { code: "SE", name: "Sweden", region: "eu" },
  CH: { code: "CH", name: "Switzerland", region: "eu" },
  SY: { code: "SY", name: "Syrian Arab Republic", region: "me" },
  TW: { code: "TW", name: "Taiwan, Province of China", region: "as" },
  TJ: { code: "TJ", name: "Tajikistan", region: "as" },
  TZ: { code: "TZ", name: "Tanzania, United Republic of", region: "af" },
  TH: { code: "TH", name: "Thailand", region: "as" },
  TL: { code: "TL", name: "Timor-Leste", region: "as" },
  TG: { code: "TG", name: "Togo", region: "af" },
  TK: { code: "TK", name: "Tokelau", region: "oc" },
  TO: { code: "TO", name: "Tonga", region: "oc" },
  TT: { code: "TT", name: "Trinidad and Tobago", region: "na" },
  TN: { code: "TN", name: "Tunisia", region: "af" },
  TR: { code: "TR", name: "Turkey", region: "me" },
  TM: { code: "TM", name: "Turkmenistan", region: "as" },
  TC: { code: "TC", name: "Turks and Caicos Islands", region: "na" },
  TV: { code: "TV", name: "Tuvalu", region: "oc" },
  UG: { code: "UG", name: "Uganda", region: "af" },
  UA: { code: "UA", name: "Ukraine", region: "eu" },
  AE: { code: "AE", name: "United Arab Emirates", region: "me" },
  GB: { code: "GB", name: "United Kingdom", region: "eu" },
  US: { code: "US", name: "United States", region: "na" },
  UM: { code: "UM", name: "United States Minor Outlying Islands", region: "oc" },
  UY: { code: "UY", name: "Uruguay", region: "sa" },
  UZ: { code: "UZ", name: "Uzbekistan", region: "as" },
  VU: { code: "VU", name: "Vanuatu", region: "oc" },
  VE: { code: "VE", name: "Venezuela", region: "sa" },
  VN: { code: "VN", name: "Viet Nam", region: "as" },
  VG: { code: "VG", name: "Virgin Islands, British", region: "na" },
  VI: { code: "VI", name: "Virgin Islands, U.s.", region: "na" },
  WF: { code: "WF", name: "Wallis and Futuna", region: "oc" },
  EH: { code: "EH", name: "Western Sahara", region: "af" },
  YE: { code: "YE", name: "Yemen", region: "me" },
  ZM: { code: "ZM", name: "Zambia", region: "af" },
  ZW: { code: "ZW", name: "Zimbabwe", region: "af" },
}
